<template>
<span class="like-btn" :title="likeTitle">
    <i :class="cls" @click.prevent="addToLikes"></i>
</span>
</template>

<script>
export default {
  name: `LikeTeacher`,

  props: {
    teacher: Object
  },

  computed: {
    inLikes() {
      if (Array.isArray(this.$store.getters.likedTeachersArray)) {
        const list = this.$store.getters.likedTeachersArray.filter((obj) => {
          if (obj.id === this.teacher.id) {
            return true;
          }
          return false;
        });
        if (list.length > 0) {
          return true;
        }
      }
      return false;
    },

    cls() {
      if (this.inLikes) {
        return `mdi mdi-heart`;
      }
      return `mdi mdi-heart-outline`;
    },
    likeTitle() {
      if (this.inLikes) {
        return `הסר מהמורים שלי`;
      }
      return `הוסף למורים שלי`;
    }
  },

  methods: {
    addToLikes() {
      this.$store.dispatch(`addRemoveTeacher`, this.teacher);
    }
  }
};
</script>

<style lang="scss">
$purple: #656b85;
$pinky: #fd7170;

.like-btn {
  .mdi {
    color: $pinky;
    &:hover {
      color: $purple;
    }
  }
}
</style>
